import { IconButton, Stack, Tooltip } from "@mui/material";
import { FaGear, FaMagnifyingGlass, FaPen, FaTrash } from "react-icons/fa6";
import { Link } from "react-router-dom";
import ListingPage from "../../components/DynamicListingPage";
import { deleteProductionStep, getProductionSteps } from "../../helpers/http_production_steps_requests";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { usePermissions } from "../../providers/PermissionsProvider";
import { confirmAndExecuteFn } from "../../utils/functions";

export default function ProductionSteps() {
    const { verifyPermission } = usePermissions();
    const queryClient = useQueryClient();
    const componentName = "logs";

    const { data, isFetching, refetch } = useQuery({
        queryKey: ["getProductionSteps"],
        queryFn: getProductionSteps,
        staleTime: 1000 * 5,
    });

    const dataList = Array.isArray(data?.data?.data) ? data.data.data : [];

    const deleteMutation = useMutation({
        mutationFn: (id) => deleteProductionStep(id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["getProductionSteps"] });
            setTimeout(() => {
                refetch();
            }, 1000);
        },
    });

    const handleDelete = (id) => {
        confirmAndExecuteFn("Tem certeza que deseja desativar esta etapa?", () => {
            deleteMutation.mutate(id);
        });
    };

    const columns = [
        { field: "id", headerName: "ID" },
        { field: "name", headerName: "Nome" },
        { field: "slug", headerName: "Slug" },
        { field: "position", headerName: "Ordem" },
        { field: "is_active", headerName: "Status" },
        { field: "actions", headerName: "Ações", type: "number" },
    ];

    const rows = dataList.map((row) => ({
        ...row,
        is_active: row.is_active ? "Ativa" : "Inativa",
    }));

    const renderActions = (row) => (
        <Stack spacing={1} direction="row" justifyContent="center">
            {verifyPermission(componentName, 1) && (
                <Tooltip title="Ver detalhes" arrow placement="top">
                    <IconButton color="primary" LinkComponent={Link} to={`/configuracao-etapa-detalhes/${row.id}`}>
                        <FaMagnifyingGlass size={20} />
                    </IconButton>
                </Tooltip>
            )}
            {verifyPermission(componentName, 2) && (
                <Tooltip title="Editar" arrow placement="top">
                    <IconButton color="primary" LinkComponent={Link} to={`/configuracao-etapa-editar/${row.id}`}>
                        <FaPen size={20} />
                    </IconButton>
                </Tooltip>
            )}
            {verifyPermission(componentName, 4) && row.is_active === "Ativa" && (
                <Tooltip title="Desativar" arrow placement="top">
                    <IconButton color="error" onClick={() => handleDelete(row.id)}>
                        <FaTrash size={20} />
                    </IconButton>
                </Tooltip>
            )}
        </Stack>
    );

    return (
        <ListingPage
            canAddData={verifyPermission(componentName, 3)}
            isLoading={isFetching}
            icon={FaGear}
            pageTitle="Etapas de Produção"
            addButtonTitle="etapa"
            addPath="/configuracao-etapa-cadastrar"
            columns={columns}
            data={rows}
            actions={renderActions}
        />
    );
}
